import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { FormSpecificEffects } from './form-specific.effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature([FormSpecificEffects])],
})
export class FormSpecificModule {}
